<script>
  export let href = undefined;
  export let variant = 'primary'; // 'primary' | 'secondary' | 'ghost'
  export let size = 'md'; // 'sm' | 'md' | 'lg'
  export let ariaLabel = undefined;
  const classes = () => {
    const base = 'btn';
    return [base, `${base}--${variant}`, `${base}--${size}`].join(' ');
  };
</script>

{#if href}
  <a class={classes()} href={href} aria-label={ariaLabel}><slot /></a>
{:else}
  <button class={classes()} aria-label={ariaLabel}><slot /></button>
{/if}

<style>
  .btn {
    display: inline-flex; align-items: center; justify-content: center;
    font-weight: 700; border-radius: 12px; cursor: pointer; user-select: none;
    transition: transform var(--speed-2) var(--e-out), filter var(--speed-2) var(--e-out), box-shadow var(--speed-2) var(--e-out);
    text-decoration: none;
    border: 1px solid transparent;
  }
  .btn--sm { padding: 10px 14px; font-size: 14px; }
  .btn--md { padding: 14px 20px; font-size: 15px; }
  .btn--lg { padding: 16px 24px; font-size: 16px; }

  .btn--primary { background: linear-gradient(90deg, var(--emerald), var(--cyan)); color: #041215; box-shadow: 0 8px 24px rgba(0,255,198,0.18); }
  .btn--primary:hover { filter: brightness(1.06); transform: translateY(-1px); }

  .btn--secondary { background: linear-gradient(90deg, rgba(0,255,198,.15), rgba(33,243,255,.15)); color: var(--fg); border: 1px solid var(--card-border); }
  .btn--secondary:hover { filter: brightness(1.05); transform: translateY(-1px); }

  .btn--ghost { background: rgba(255,255,255,0.02); color: var(--fg); border: 1px solid var(--card-border); }
  .btn--ghost:hover { background: rgba(255,255,255,0.03); }

  .btn:focus-visible { outline: 2px solid var(--emerald); outline-offset: 2px; }
</style>
